import { IconEdit, IconRefreshDot, IconToggleLeftFilled, IconToggleRightFilled } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { getApi, postApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal';
import TableComponent from '../../components/DataTable/TableComponent';
import DateRange from '../../components/DateRange/DateRange';
import DropDown from '../../components/DropDown/DropDown';
import TableImage from '../../components/ImageComponent/TableImage';
import SearchComponent from '../../components/Search/SearchComponent';
import Layout from '../../layout/Layout';
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller';
import { dateIntoYYYY_MM_DD, dateTimeConverter } from '../../utils/dateTimeConverter';
import UpdateUserDetails from './Components/UpdateUserDetails';
import { Badge } from 'react-bootstrap';
import AssignChatPlanModal from './Components/AssignChatPlanModal';
import GeneratePaymentLinkModal from './Components/GeneratePaymentLinkModal';

const Users = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const [activePage, setActivePage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [date, setDate] = useState({ startDate: '', endDate: '' });
    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    });
    const [searchData, setSearchData] = useState('');
    const [statusFilter, setStatusFilter] = useState(null);
    const [domainFilter, setDomainFilter] = useState(null);

    const statusList = [
        {
            id: null,
            name: "All"
        }, {
            id: 1,
            name: "Active"
        }, {
            id: 2,
            name: "Inactive"
        }
    ]
    const domainList = [
        {
            id: null,
            name: "All"
        }, {
            id: "chat",
            name: "Chat"
        }, {
            id: "app",
            name: "App"
        }
    ]

    function handlePageChange(page) {
        setActivePage(page);
    }

    function handlePerRowsChange(newPerPage, page) {
        setActivePage(page);
        setPerPage(newPerPage);
    }

    function onDateChange(p) {
        if (state) {
            navigate('/users', { replace: true, state: {} });
        }
        let newDate = { startDate: p.startDate._d, endDate: p.endDate._d }
        setActivePage(1);
        setDate(newDate)
    }

    async function getAllUser() {
        loadingShow();
        let postData = {
            "startDate": dateIntoYYYY_MM_DD(date.startDate),
            "endDate": dateIntoYYYY_MM_DD(date.endDate)
        }
        let statusFilterLocal = statusList?.find(item => item?.name == statusFilter);
        let domainFilterLocal = domainList?.find(item => item?.name == domainFilter);
        let url = `${urlApi.getAllUsers}?page=${activePage}&limit=${perPage}`;
        if (searchData) {
            url += `&search=${searchData}`
        }
        if (statusFilterLocal?.id) {
            url += `&filterByStatus=${statusFilterLocal ? statusFilterLocal?.id : null}`;
        }
        if (domainFilterLocal?.id) {
            url += `&signUpDomain=${domainFilterLocal ? domainFilterLocal?.id : null}`;
        }
        if (state == "TODAY_ACTIVE") {
            url += `&filter=1`;
        }
        let resp = await postApi((postData?.startDate ? postData : {}), url);
        loadingHide();
        if (resp.responseCode === 200) {
            setTableData({
                data: resp.data?.items,
                totalCount: resp.data?.count
            })
        } else {
            setTableData({
                data: [],
                totalCount: 0
            });
            toast.error(resp.message);
        }
    }

    useEffect(() => {
        // if (accessCheck(accessKeys.getUserList)) {
        getAllUser();
        // }
    }, [activePage, perPage, searchData, statusFilter, date, domainFilter])

    async function updateStatus(id, status) {
        loadingShow();
        let resp = await getApi(`${urlApi.updateUserStatus}${id}/${status}`);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            getAllUser();
        } else {
            toast.error(resp.message);
        }
    }

    function onStatusFilterChange(status) {
        setActivePage(1);
        setStatusFilter(status)
    }

    function onDomainFilterChange(status) {
        setActivePage(1);
        setDomainFilter(status)
    }

    function resetAll() {
        setActivePage(1);
        setPerPage(10);
        setSearchData(null);
        setStatusFilter(null);
        setDomainFilter(null)
        setDate({ startDate: '', endDate: '' });
        if (state) {
            navigate('/users', { replace: true, state: {} });
        }
        document.getElementById("user-table-search").value = ""
    }

    const columns = [
        { name: "Sl. No", center: "true", width: "60px", selector: (row) => row?._id, cell: (row, index) => (activePage - 1) * perPage + (index + 1) },
        {
            name: "Name", center: "true", selector: (row) => row?.name, cell: (row) => (
                <Link to={"/user/" + row?._id}>
                    <div className='flex items-center gap-2 py-2'>
                        <TableImage imageUrl={row?.profilePic} altText={row?.name} />
                        <div className='text-center'>
                            <p className='fw-bold'>{row?.name}</p>
                        </div>
                    </div>
                </Link>
            ),
        },
        { name: "Mobile", center: "true", selector: (row) => row?.phone, cell: (row) => (<span> {row?.phone ?? "--"}</span>), },
        { name: "Email", center: "true", selector: (row) => row?.email, cell: (row) => row?.email || "--", },
        {
            name: "Registered", center: "true", selector: (row) => row?.createdAt, cell: (row) =>
                <div>
                    <Badge className='mb-1' bg={row?.signUpDomain?.includes("chat") ? "primary" : "warning"}>{row?.signUpDomain}</Badge>
                    <p>{dateTimeConverter(row?.createdAt)}</p>
                </div>
        },
        {
            name: "Last Login", center: "true", selector: (row) => row?.lastLogin, cell: (row) => <div className='flex flex-col gap-1 justify-center items-center'>
                <div className='flex gap-1'>
                    {row?.userPlatform && <p className={`${row?.userPlatform == "app" ? 'bg-indigo-300' : row?.userPlatform == "web" ? "bg-yellow-200" : "bg-purple-800"} text-blue-800 text-[10px] font-medium px-2 py-0.5 rounded max-w-fit capitalize`}>{row?.userPlatform}</p>}
                </div>
                <p>{dateTimeConverter(row?.lastLogin)}</p>
            </div>
            ,
        },
        {
            name: "Earnings", center: "true", selector: (row) => row?.createdAt, cell: (row) =>
                <p>₹ {row?.balance?.toFixed(2) || 0} </p>
        },
        {
            name: "Org.", center: "true", width: '60px', selector: (row) => row?.createdAt, cell: (row) =>
                <Link target='_blank' to={'/user-org-list/' + row?._id}> <Badge bg='info'>Org. List</Badge> </Link>
        },
        {
            name: "Status", center: "true", selector: (row) => row?.status, width: "60px", cell: (row) =>
                // accessCheck(accessKeys.updateUserStatus) ?
                <ConfirmationModal
                    buttonComponent={row?.status == 1 ? <IconToggleRightFilled className='text-green-600 cursor-pointer transition-all' /> : <IconToggleLeftFilled className='text-red-700 cursor-pointer transition-all' />}
                    confirmationText={`Are You Sure Want To ${row?.status == 1 ? 'Deactivate' : "Activate"} ${row?.name} ?`}
                    onConfirm={() => updateStatus(row?._id, row?.status == 1 ? 2 : 1)}
                />
            //  :   row?.status == 1 ? <IconToggleRightFilled className='text-green-600 transition-all' /> : <IconToggleLeftFilled className='text-red-700 transition-all' />
        },
        {
            name: "Action", center: "true", selector: (row) => row?.action, cell: (row) =>
                <div className='flex flex-wrap gap-2 items-center justify-center'>
                    <UpdateUserDetails userData={row} callback={() => getAllUser()} buttonComponent={<button className='p-2 rounded-md hover:bg-gray-100 transition' ><IconEdit size={20} /></button>} />
                    <GeneratePaymentLinkModal />
                    <AssignChatPlanModal userData={row} />
                </div>
        },
    ];

    return (
        <Layout>

            <div className='flex items-center mb-3 justify-between'>
                <h1 className='text-xl font-bold text-gray-600'>
                    {/* {state == "TODAY_ACTIVE" && 'Today Active'}  */}
                    Users</h1>
            </div>

            {/* {accessCheck(accessKeys.getUserList) && */}
            <div className='flex mb-3 justify-between items-center flex-wrap gap-2'>
                <SearchComponent onClear={() => { document.getElementById("user-table-search").value = ""; setSearchData('') }} inputValue={searchData}
                    onSearch={() => { setSearchData(document.getElementById("user-table-search")?.value); setActivePage(1) }} inputId='user-table-search' placeholder={"Name / Mobile / Email"} />
                <div className="ms-auto"></div>
                <DateRange onApplyClick={(date) => onDateChange(date)} date={date} cssClass={'ms-auto'} />

                <DropDown title={"Status"} list={statusList?.map(item => item?.name)} defaultValue={statusFilter} onSelect={(name) => onStatusFilterChange(name)} />

                <DropDown title={"Domain"} list={domainList?.map(item => item?.name)} defaultValue={domainFilter} onSelect={(name) => onDomainFilterChange(name)} />

                <IconRefreshDot className='cursor-pointer text-[var(--secondary-gradient-1)]' onClick={() => resetAll()} />

            </div>
            {/* } */}

            {/* {accessCheck(accessKeys.getUserList) && */}
            <TableComponent
                columns={columns}
                data={tableData.data}
                totalRows={tableData.totalCount}
                isPagination={true}
                handlePageChange={(e) => handlePageChange(e)}
                handlePerRowsChange={(newPerPage, page) => handlePerRowsChange(newPerPage, page)} />
            {/* } */}

        </Layout>
    )
}

export default Users